import { render, staticRenderFns } from "./materialBindDialog.vue?vue&type=template&id=f7e4d5fc&scoped=true&"
import script from "./materialBindDialog.vue?vue&type=script&lang=js&"
export * from "./materialBindDialog.vue?vue&type=script&lang=js&"
import style0 from "./materialBindDialog.vue?vue&type=style&index=0&id=f7e4d5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e4d5fc",
  null
  
)

export default component.exports